(function (Drupal, $, once) {
    Drupal.behaviors.mo22 = {
        attach() {

            var idPrefix = 'link-';
            var linkClass = 'MO22__link';
            var activeClass = 'MO22__link--active';
            var horizontalBreakpointMax = 1280;
            var stickyClass = 'MO22--sticky';

            var $sections = $('.in-floating-menu');
            var $menuContainer = $('.MO22__menu-items');

            const $arrowRight = $('.MO22__arrows:last-of-type');
            const $arrowLeft = $('.MO22__arrows:first-of-type');
            const scrollMovement = '60px';

            const arrowStatuses = {
                LEFT: 'left',
                RIGHT: 'right',
                BOTH: 'both',
                NONE: 'none'
            };


            var headerObserver = null;
            var contentObserver = null;

            function isHorizontal() {
                return window.innerWidth < horizontalBreakpointMax;
            }

            function buildSectionID(id) {
                return '#' + idPrefix + id;
            }

            function constructObserver(observer, handler, margin) {
                if (observer) {
                    // Destroy observer if already in place
                    observer.disconnect();
                    observer = null;
                }
                return new IntersectionObserver(handler, {rootMargin: margin});
            }

            function addMenuItem(container, title, id) {
                var link = $('<a />', {
                    text: title,
                    href: '#' + id,
                    class: linkClass + ' w-tab-link', // w-tab-link tells webflow not to interfere
                    id: idPrefix + id
                });
                container.append($('<li>').addClass('MO22__menu-item').append(link));
            }

            function toggleActiveLink(id) {
                // Toggle the active class on selected link
                $menuContainer.find(`.${linkClass}`).removeClass(activeClass);
                $menuContainer.find(buildSectionID(id)).addClass(activeClass);

                if (isHorizontal()) {
                    // Make sure active link is visible for horizontal list of links
                    $menuContainer.find(buildSectionID(id))[0].scrollIntoView({block: 'nearest'});
                } else {
                    // Animate the active link indicator to the correct position
                    const first = $menuContainer.find(`.${linkClass}`)[0].getBoundingClientRect().top;
                    const current = $menuContainer.find(buildSectionID(id))[0].getBoundingClientRect().top;
                    $('.MO22__active-train').css('transform', 'translateY(' + (current - first) + 'px)');
                }
            }

            /*
                Setup observers for page sections. These observers update the menu's active link indicator
             */
            function observeSections() {
                const sections = [...document.querySelectorAll('.in-floating-menu')];
                const onIntersect = (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            // Section is visible, mark its link as active
                            toggleActiveLink($(entry.target).attr('id'));
                        }
                    })
                }
                const observer = new IntersectionObserver(onIntersect, {
                    threshold: 0,
                    rootMargin: '-20% 0px -30% 0px'
                });
                sections.forEach((section) => {
                    observer.observe(section);
                })
            }

            /*
                Setup observer for header. This informs menu when it should become sticky
             */
            function observeHeader() {
                const ghostHeader = document.querySelector('.MO22__ghost');
                const headerHeight = $(ghostHeader).height();
                const height = $('.MO19').height();
                const headerHandler = (entries) => {
                    const shouldStick = !entries[0].isIntersecting;

                    const pastHeader = ($(window).scrollTop() + height + 1) >= $('.MO22__ghost').offset().top;
                    if (shouldStick && pastHeader) {
                        // Ghost menu is no longer visible, indicating menu should become sticky
                        $('.MO22').addClass(stickyClass);
                    } else {
                        $('.MO22').removeClass(stickyClass);
                    }
                }
                headerObserver = constructObserver(headerObserver, headerHandler, `-${headerHeight + height + 1}px 0px 0px 0px`);
                headerObserver.observe(ghostHeader);
            }

            /*
                Setup observer for content. This informs menu when it should be hidden so it does not overlap footer
             */
            function observeContent() {
                const main = document.querySelector('main');
                const $menu = $('.MO22');
                const height = $('.MO19').height();
                const layoutMargin = $('.layout--ukho:last').css('margin-bottom');
                const offset = $menu[0].getBoundingClientRect().height +
                    parseInt($menu.css('margin-top')) +
                    parseInt(layoutMargin) + height;
                const contentHandler = (entries) => {
                    const shouldStick = entries[0].isIntersecting;
                    if (!shouldStick) {
                        // No longer intersecting main content, stick menu
                        $('.MO22').addClass('MO22--stuck');

                    } else {
                        $('.MO22').removeClass('MO22--stuck');
                    }
                }
                contentObserver = constructObserver(contentObserver, contentHandler, `-${offset}px 0px 0px 0px`);
                contentObserver.observe(main);
            }

            function buildMenu() {
                $('.MO22').removeClass('MO22--hidden');
                $('.MO22__ghost').removeClass('MO22__ghost--hidden');
                $menuContainer.empty();
                $sections.each(function () {
                    addMenuItem($menuContainer, $(this).data('nav-title'), $(this).attr('id'));
                });
                $menuContainer.find(`.${linkClass}`).first().addClass(activeClass);
            }

            function isObserverSupported() {
                return "IntersectionObserver" in window;
            }

            function shouldBuildMenu() {
                return $sections.length > 0
            }

            // Checks if a fragment exists in URL on load, and navigates if so
            function checkFragment() {
                if (window.location.hash) {
                    var hash = window.location.hash.substring(1);
                    setTimeout(() => {
                        $(buildSectionID(hash)).click();
                    });
                }
            }

            /**
             * @param {('both'|'none'|'left'|'right')}  status  Manage arrows status.
             */
            function hideShowArrow(status) {
                switch (status) {
                    case arrowStatuses.BOTH:
                        $arrowRight.hide();
                        $arrowLeft.hide();
                        break;
                    case arrowStatuses.NONE:
                        $arrowRight.show();
                        $arrowLeft.show();
                        break;
                    case arrowStatuses.LEFT:
                        $arrowRight.show();
                        $arrowLeft.hide();
                        break;
                    case arrowStatuses.RIGHT:
                        $arrowRight.hide();
                        $arrowLeft.show();
                        break;
                }
            }

            /**
             * Check the status of the scroll.
             */
            function checkScrollStatus() {
                let arrowStatus = arrowStatuses.NONE;
                const totalScroll = $menuContainer.prop('scrollWidth');
                const elementWidth = $menuContainer.width();
                const scrollPosition = $menuContainer.scrollLeft();
                const scrollValue = Math.round((100 * scrollPosition) / (totalScroll - elementWidth));

                // Manage scroll position cases.
                if (totalScroll <= elementWidth) {
                    arrowStatus = arrowStatuses.BOTH;
                } else if (scrollValue === 0) {
                    arrowStatus = arrowStatuses.LEFT;
                } else if (scrollValue === 100) {
                    arrowStatus = arrowStatuses.RIGHT;
                } else {
                    arrowStatus = arrowStatuses.NONE;
                }

                // Hide or show arrows.
                hideShowArrow(arrowStatus);
            }

            /**
             * Hide and show arrows based on scroll percentage.
             */
            function onMenuScroll() {
                $menuContainer.scroll(function () {
                    checkScrollStatus();
                });
            }

            /**
             * Control scroll with arrow buttons.
             */
            function controlScrollWithArrows() {
                $arrowRight.click(function () {
                    $menuContainer.animate({
                        scrollLeft: "+=" + scrollMovement
                    }, "slow");
                });

                $arrowLeft.click(function () {
                    $menuContainer.animate({
                        scrollLeft: "-=" + scrollMovement
                    }, "slow");
                });
            }

            /*
                Initialises navigation menu
             */
            function bootComponent() {
                if (shouldBuildMenu()) {
                    buildMenu();
                    checkFragment();
                    if (isObserverSupported()) {
                        observeSections();
                        observeHeader();
                        observeContent();
                    }
                }
                checkScrollStatus();
                onMenuScroll();
                controlScrollWithArrows();
            }

            $(window).resize(function () {
                clearTimeout($.data(this, 'resizeTimer'));
                $.data(this, 'resizeTimer', setTimeout(function () {
                    // Update the observer margins on viewport resize
                    if (isObserverSupported()) {
                        observeHeader();
                        observeContent();
                    }
                }, 200));
                checkScrollStatus();
                // Debounced to reduce amount of invocations
            });

            // Perform anchor scroll on menu click event
            // We don't use native functionality because Safari does not support smooth scroll
            $(once('MO22', 'body')).first().each(function () {
                $(document).on('click', '.MO22__menu-items a', function (event) {
                    event.preventDefault();
                    // Figure out the offset
                    const mainNavHeight = $('.MO19').height();
                    var offset = parseInt($('.MO22').css('margin-top'));
                    if (isHorizontal()) {
                        offset = $('.MO22').height() + 15;
                    }

                    // Perform the scroll
                    $('html, body').animate({
                        scrollTop: $($.attr(this, 'href')).offset().top - mainNavHeight - offset
                    }, 500);

                    // Update the URL fragment
                    window.location.hash = $.attr(this, 'href');
                });

                bootComponent();
            });
        }
    };
})(Drupal, jQuery, once);
